import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsTpamsConstants {
    static COMPONENT_NAME = "TPAMSCreateApplication";
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static FILE_NUMBER_LABEL = "File number";
    static AMENDMENT_SCHEME_NUMBER_LABEL = "Amendment scheme number";
    static APPLICATION_TYPE_LABEL = "Applications type";
    static ZONE_LABEL = "New property zone";
    static PREVIOUS_REFERENCE_NUMBER_LABEL = "Previous reference number";
    static IS_RESUBMISSION_LABEL = "Is this application a resubmission?";
    static VERIFY_LABEL = "Verify";
    static ACCEPT_LABEL = "I, Accept";
    static AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME = "amendmentSchemeNumber";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPES_FORM_CONTROL_NAME = "applicationTypes";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static ZONES_FORM_CONTROL_NAME = "zones";
    static ZONE_FORM_CONTROL_NAME = "zone";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME = "previousReferenceNumber";
    static IS_RESUBMISSION_FORM_CONTROL_NAME = "isResubmission";
    static ACCEPT_FORM_CONTROL_NAME = "acceptDisclaimer";
    static ADD_APPLICATION_TYPE_LABEL = "Add application type";
    static ADD_ZONE_LABEL = "Add zone";
    static DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE = "This application type has already been added.";
    static DUPLICATE_ZONE_WARNING_MESSAGE = "This zone has already been added.";
    static ALL_APPLICATION_TYPES_ADDED_WARNING_MESSAGE = "All available application types have already been added.";
    static ALL_ZONES_ADDED_WARNING_MESSAGE = "All available zones have already been added.";
    static REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME = "rezoneConfirmation";
    static REZONING_APPLICATION_CONFIRMATION_LABEL = "Is the application a rezoning application?";
    static REZONING_KEYWORD_REZONING = "rezoning";
    static REZONING_KEYWORD_REZONE = "rezone";
    static UNLIMITED_APPLICATION_TYPE_LIMIT = -1;
    static APPLICATION_TYPE_LIMIT_REACHED_WARNING_MESSAGE = "Application type limit reached. You cannot add more application types.";
    static RESUBMISSION_VERIFICATION_MESSAGE = "Reference number verification successful";
    static RESUBMISSION_DISCLAIMER_TITLE = "Resubmission Disclaimer title not configured, please contact your system administrator";
    static RESUBMISSION_DISCLAIMER_CONTENT = "Resubmission Disclaimer content not configured, please contact your system administrator";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        previousReferenceNumber: {
            required: `Previous reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isResubmission: {
            required: `Is Resubmission ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
